import manifest from './manifest';
import Entry from './pages/Entry';
import FAQ from './pages/FAQ';
import TermsAndConditions from './pages/TermsAndConditions';
import EveryBodyWins from './pages/EveryBodyWins';

const classicTemplate = {
  manifest,
  pages: {
    Entry,
    FAQ,
    TermsAndConditions,
    EveryBodyWins
  }
};

export default classicTemplate;
